module.exports = __webpack_public_path__ + "static/img/m_role.2e90aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/swbnzk/m_role.png
// module id = Xxfx
// module chunks = 7